import { atom } from 'recoil';

export const contractsState = atom({
  key: 'contractsState',
  default: [],
});
